/** GraphQL for the watermark library SDOs (VE-24693). Mirrors settingsProfile. */

/**
 * Resolve the registry's published schema.
 *
 * Deliberately ours rather than the shared `getLatestSchemaId`: we need to tell
 * "the registry answered and has no published schema" apart from "the request
 * failed", and that helper returns `undefined` for both.
 */
export const fetchWatermarkSchemaQuery = `
  query fetchWatermarkSchema($dataRegistryId: ID!) {
    dataRegistry(id: $dataRegistryId) {
      id
      publishedSchema { id }
    }
  }
`;

/**
 * The whole library, in one request.
 *
 * **`data` is a single `JSONData` scalar, not a selection set.** There is no way
 * to ask this query for a subset of a row's keys — GraphQL cannot project
 * inside a scalar — so whatever the SDO holds arrives in full, on every row.
 *
 * That is why the artwork moved out. An image row used to carry two full-size
 * base64 rasters (`imageBaseDataUrl` for thumbnails and `sourceDataUrl` for the
 * Download button) and there was no query-side way to leave either behind. Both
 * now live on the watermark's own TDO as assets, and the row keeps only a small
 * `previewDataUrl` — a change to the STORED SHAPE, because no change to this
 * query could have achieved it.
 *
 * What CAN be trimmed here is the number of ROWS, via the `filter` argument —
 * see the caution about absent keys in `services/index.ts`.
 *
 * Whole records are also load-bearing on the settings page specifically:
 * `findRecord` hands `raw` to an upsert and `createStructuredData` REPLACES the
 * whole document, so a record fetched without a field is a record that loses
 * that field the next time someone flips the Enabled switch.
 */
export const fetchWatermarksQuery = `
  query fetchWatermarks($schemaId: ID!, $limit: Int, $offset: Int, $filter: JSONData) {
    structuredDataObjects(schemaId: $schemaId, limit: $limit, offset: $offset, filter: $filter) {
      count
      records {
        id
        createdDateTime
        modifiedDateTime
        data
      }
    }
  }
`;

// create + update are the same upsert: omit `id` to insert, pass it to update.
export const upsertWatermarkQuery = `
  mutation upsertWatermark($id: ID, $data: JSONData!, $schemaId: ID!) {
    createStructuredData(input: { id: $id, data: $data, schemaId: $schemaId }) {
      id
      data
      createdDateTime
      modifiedDateTime
    }
  }
`;

export const deleteWatermarkQuery = `
  mutation deleteWatermark($id: ID!, $schemaId: ID!) {
    deleteStructuredData(input: { id: $id, schemaId: $schemaId }) {
      id
    }
  }
`;
